import React, { useEffect, useState } from 'react';
import { Translate } from 'react-redux-i18n';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../hooks';
import { RootState } from '../../../store';
import { getFranchise } from '../../franchises/store/franchiseActions';
import FranchiseInput from '../../franchises/input/FranchiseInput';
import Spinner from '../../../components/common/spinner';

/**
 * Edit Franchise content - designed to be embedded in SystemSettings container.
 */
const EditFranchiseContent = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [loaded, setLoaded] = useState(false);
  const franchiseState = useSelector((s: RootState) => (s as any).franchise);

  useEffect(() => {
    if (id) dispatch(getFranchise(Number(id)) as any);
  }, [id, dispatch]);

  useEffect(() => {
    if (franchiseState?.recordEdit?.ready === 0 && franchiseState?.recordEdit?.data) {
      setLoaded(true);
    }
  }, [franchiseState?.recordEdit]);

  if (!loaded) {
    return <Spinner />;
  }

  return (
    <>
      <h2>
        <Translate value={'franchises.page.edit.title'} />
      </h2>
      <FranchiseInput mode='edit' initialValue={franchiseState?.recordEdit?.data} />
    </>
  );
};

export default EditFranchiseContent;
